/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { oneSecond } from '../../../Common/constants';
import { setPayersFilters } from '../../actions';
import { getPayersFilters } from '../../selectors';
import { payersFiltersInitialState } from '../../reducers';
import { getAggregatorOptions } from '../../services';
import { dropDownDefault } from '../../services/constants';

const usePayersFilterBar = () => {
  const storeFilters = useSelector(getPayersFilters);
  const setStoreFilters = useAction(setPayersFilters);
  const debouncedFilterChange = useCallback(debounce(setStoreFilters, oneSecond), []);
  const [aggregatorOptions, setAggregatorOptions] = useState(dropDownDefault);
  const [showResetButton, setShowResetButton] = useState(false);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    const callFilterOptions = async () => {
      const aggregatorFilterOptions = await getAggregatorOptions();

      setAggregatorOptions(aggregatorFilterOptions);
    };

    callFilterOptions();

    return () => setStoreFilters({ ...payersFiltersInitialState });
  }, []);

  useEffect(() => {
    debouncedFilterChange(filters);
    setShowResetButton(!isEqual(filters, payersFiltersInitialState));
  }, [filters]);

  const handleFilterChanges =
    filterName =>
    ({ target: { value } }) => {
      const filter = { [filterName]: value };

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...payersFiltersInitialState });
  };

  return {
    aggregatorOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    filters,
  };
};

export default usePayersFilterBar;
